<template>
  <header :style="{ background: customisations.bg_color }" v-if="customisations">
    <div class="header-loggedin">
      <i class="fa fa-user"></i>
      {{username}}
      <br>
      <a @click.prevent="logOut" href="#">
        <i class="fa fa-sign-out"></i> Log out
      </a>
    </div>
    <img :alt="customisations.agency_name" :src="customisations.image" class="logo header-logo">
    <div class="header-title">
      {{customisations.site_name}}
      <span>
        <span>Content Management System</span>
        <span>CMS</span>
      </span>
    </div>
  </header>
</template>

<script>
import cognito from "@/services/cognito"

export default {
  name: "HeaderComponent",
  computed: {
    username: function() {
      return this.$store.getters["user/username"]
    },
    customisations: function() {
      return this.$store.state.customisations
    }
  },
  methods: {
    logOut: function() {
      cognito.logOut()
    }
  }
}
</script>
